export default
{
    props:
    {
        content: { type: Object, default: null }
    },

    data()
    {
        return {
            isExpanded: false
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
    },

    mounted()
    {
        this.$header = this.$el.querySelector('.js-header')
        this.$container = this.$el.querySelector('.js-container')

        this.onResize()
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
    },

    methods:
    {
        onResize()
        {
            this._baseHeight = this.$header.offsetHeight
            this._fullHeight = this.$container.offsetHeight

            if(!this.isExpanded)
            {
                this.$el.style.height = this._baseHeight + 'px'
            }

        },

        onToggleItem()
        {
            this.isExpanded = !this.isExpanded

            if(this.isExpanded)
            {
                this.$el.style.height = this._fullHeight + 'px'
                this.$el.classList.add('is-expanded')
            }
            else
            {
                this.$el.style.height = this._baseHeight + 'px'
                this.$el.classList.remove('is-expanded')
            }
        },

        onProjectOver(src)
        {
            this.$emit('project:hover', src)
        },

        onProjectLeave()
        {
            this.$emit('project:leave')
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-client-item/script.js